import {RequireAtLeastOne} from 'type-fest';
import {type IAsset} from '../schema';
import {getAssetImageUrl} from './getAssetImageUrl';

export const getAllAssetImageUrls = (
	asset?: Pick<IAsset, 'assetId' | 'jwt' | 'moddate'> &
		RequireAtLeastOne<Pick<IAsset, 'thumbUrl' | 'previewUrl' | 'zoomUrl'>>,
	queryParams?: Record<string | number, string | number>,
) => {
	return {
		thumb: getAssetImageUrl(asset, {queryParams, size: 'thumb'}),
		preview: getAssetImageUrl(asset, {queryParams, size: 'preview'}),
		zoom: getAssetImageUrl(asset, {queryParams, size: 'zoom'}),
	};
};
